import { i18n as globalI18n, Messages } from '@lingui/core';

const initI18n = (locale: string, messages: Messages): void => {
  globalI18n.load(locale, messages);
  globalI18n.activate(locale);
};

export default initI18n;
